var map = {
	"./bus.png": "ab57",
	"./car.png": "922e",
	"./estate.png": "e2bb",
	"./motorbike.png": "d861",
	"./pickup.png": "ba23",
	"./taxi.png": "0200",
	"./truck.png": "a3f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1535";